import { useTranslation } from 'react-i18next';
import { useEffectOnce } from 'react-use';
import c2foComputerColor from '@/enterprise/assets/c2focomputer-color.svg?url';
import { useIntercom } from '@/reporting/Intercom';
import { useReporting } from '@/reporting/Reporting';
import { ButtonLink } from '@/shared/components/ButtonLink';
import { asEnterpriseLink } from '@/utils/experienceLinkHelper';
import { useOfferBuilderContext } from '../OfferBuilderContext';
import OfferSummary from '../OfferSummary';
import ErrorDetails from './ErrorDetails';
import NextSteps from './NextSteps';

const OfferConfirmation = () => {
  const { t } = useTranslation();
  const { trackEnterpriseEvent } = useReporting();
  const { triggerNPSSurvey } = useIntercom();
  const {
    state: { submissionErrors, builderVariant },
  } = useOfferBuilderContext();
  const isAcquisition = builderVariant === 'acquisition';

  useEffectOnce(() => {
    triggerNPSSurvey();
  });

  const handleViewOfferActivityClick = () => {
    trackEnterpriseEvent('offer-confirmation::view-offer-activity::clicked');
  };

  return (
    <div className="space-y-6 pb-6 md:mx-0 md:rounded-md">
      <div className="flex flex-col gap-4 rounded-lg border-[0.5px] border-stroke bg-lightBlue-100 p-6 lg:flex-row lg:items-center">
        <div className="flex items-center gap-5">
          <div className="shrink-0">
            <img src={c2foComputerColor} alt="c2fo computer" className="size-20" />
          </div>
          <div>
            <div className="text-lg font-medium">{t('offerConfirmation.trackYourOffer')}</div>
            <div>
              {t(
                isAcquisition
                  ? 'offerConfirmation.headToOfferActivity.acquisition'
                  : 'offerConfirmation.headToOfferActivity'
              )}
            </div>
          </div>
        </div>
        <div className="shrink-0 lg:ml-auto">
          <ButtonLink className="w-fit" to={asEnterpriseLink('offer-activity')} onClick={handleViewOfferActivityClick}>
            {t('offerConfirmation.viewOfferActivity')}
          </ButtonLink>
        </div>
      </div>
      {submissionErrors.length > 0 ? <ErrorDetails /> : null}
      <div className="flex flex-col gap-6 lg:flex-row">
        <NextSteps />
        <div className="lg:w-7/12 lg:shrink-0">
          <div className="mb-2 text-lg font-medium">{t('builder.offerSummary')}</div>
          <OfferSummary step="confirmation" offerSubmitting={false} />
        </div>
      </div>
    </div>
  );
};

export default OfferConfirmation;
